export const booleanOptions = [
    {
        label: "Ya",
        value: true,
    },
    {
        label: "Tidak",
        value: false,
    },
];

export const speedOptions = [
    {
        label: "Kb/s",
        value: 1,
    },
    {
        label: "Mb/s",
        value: 1_000,
    },
    {
        label: "Gb/s",
        value: 1_000_000,
    },
];

export const timeOptions = [
    {
        label: "DETIK",
        value: 1,
    },
    {
        label: "MENIT",
        value: 60,
    },
    {
        label: "JAM",
        value: 3_600,
    },
    {
        label: "HARI",
        value: 86_400,
    },
    {
        label: "BULAN",
        value: 2_592_000,
    },
];

export const paperOptions = [
    {
        label: "A4 Portrait (210mm x 297mm)",
        value: {
            width: 210,
            height: 297,
        },
    },
    {
        label: "A4 Landscape (297mm x 210mm)",
        value: {
            width: 297,
            height: 210,
        },
    },
    {
        label: "F4 Portrait (210mm x 330mm)",
        value: {
            width: 210,
            height: 330,
        },
    },
    {
        label: "F4 Landscape (330mm x 210mm)",
        value: {
            width: 330,
            height: 210,
        },
    },
];

export const taxOptions = [
    {
        label: "Tidak Ada",
        value: "none",
    },
    {
        label: "PPN",
        value: "ppn",
    },
    // {
    //     label: "Custom",
    //     value: "custom",
    // },
] as const;

export const discountOptions = [
    {
        label: "Tidak Ada",
        value: "none",
    },
    {
        label: "Rupiah (Rp.)",
        value: "currency",
    },
    {
        label: "Persentase (%)",
        value: "percentage",
    },
] as const;

export const wanTypeOptions = [
    {
        label: "IP",
        value: "IP",
    },
    {
        label: "PPP",
        value: "PPP",
    },
];

export const wanModeOptions = [
    {
        label: "Route",
        value: "Route",
    },
    {
        label: "Bridge",
        value: "Bridge",
    },
];

export const onlineStatusOptions = [
    {
        label: "ONLINE",
        value: true,
    },
    {
        label: "OFFLINE",
        value: false,
    },
];
